// PWA install prompt + service worker registration.
// Imported once from main.jsx.

(function () {
  if (typeof window === 'undefined') return;

  // ── Service Worker registration ──
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((reg) => {
          // Auto-update when a new SW activates
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // a new version is available — silently auto-update next visit
                  console.log('[PWA] New version installed, will activate on next reload.');
                }
              });
            }
          });
        })
        .catch((err) => console.warn('[PWA] SW registration failed:', err));
    });
  }

  // ── Install prompt banner ──
  let deferredPrompt = null;

  function ensureBannerStyles() {
    if (document.getElementById('pwa-banner-styles')) return;
    const style = document.createElement('style');
    style.id = 'pwa-banner-styles';
    style.textContent = `
      #pwa-install-banner {
        position: fixed; bottom: 16px; left: 16px; right: 16px;
        max-width: 480px; margin: 0 auto;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white; padding: 14px 16px;
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.2);
        display: flex; align-items: center; gap: 12px;
        z-index: 99999; font-family: -apple-system, sans-serif;
        animation: pwa-slide-up 0.35s ease-out;
      }
      @keyframes pwa-slide-up { from { transform: translateY(120%); } to { transform: translateY(0); } }
      #pwa-install-banner .pwa-icon { font-size: 24px; }
      #pwa-install-banner .pwa-text { flex: 1; font-size: 14px; line-height: 1.3; }
      #pwa-install-banner .pwa-text b { display: block; font-size: 15px; }
      #pwa-install-banner button {
        border: none; padding: 8px 14px; border-radius: 8px; font-weight: 600;
        font-size: 13px; cursor: pointer; flex-shrink: 0;
      }
      #pwa-install-banner .pwa-install { background: white; color: #667eea; }
      #pwa-install-banner .pwa-dismiss {
        background: transparent; color: white; opacity: 0.8;
      }
      @media (max-width: 480px) {
        #pwa-install-banner { padding: 12px; gap: 8px; }
        #pwa-install-banner .pwa-text { font-size: 13px; }
      }
    `;
    document.head.appendChild(style);
  }

  function showInstallBanner() {
    if (document.getElementById('pwa-install-banner')) return;
    if (localStorage.getItem('pwa-install-dismissed') === '1') return;
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    ensureBannerStyles();

    const banner = document.createElement('div');
    banner.id = 'pwa-install-banner';
    banner.innerHTML = `
      <div class="pwa-icon">📱</div>
      <div class="pwa-text">
        <b>Установить Workify.pl</b>
        Быстрый доступ — как обычное приложение
      </div>
      <button class="pwa-install">Установить</button>
      <button class="pwa-dismiss" aria-label="Скрыть">✕</button>
    `;
    document.body.appendChild(banner);

    banner.querySelector('.pwa-install').addEventListener('click', async () => {
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      deferredPrompt = null;
      banner.remove();
      if (outcome === 'dismissed') {
        localStorage.setItem('pwa-install-dismissed', '1');
      }
    });
    banner.querySelector('.pwa-dismiss').addEventListener('click', () => {
      banner.remove();
      localStorage.setItem('pwa-install-dismissed', '1');
    });
  }

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    // small delay so the user sees the page first
    setTimeout(showInstallBanner, 3500);
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    const b = document.getElementById('pwa-install-banner');
    if (b) b.remove();
    console.log('[PWA] Installed.');
  });
})();
